import React from "react";

/**
 * This input widget modifies the input to lowercase.
 * But only, if it is in Create-Mode, because the old
 * urls should not be modified.
 */
export class LowerCaseInput extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isUpdate: this.props.value !== undefined
    };
  }

  localOnChange(value) {
    this.props.onChange(value.toLowerCase());
  }

  render() {
    const { forID, classNameWrapper, value } = this.props;

    return (
      <div>
        <input
          type="text"
          id={forID}
          className={classNameWrapper}
          value={value || ""}
          onChange={e => this.localOnChange(e.target.value)}
          style={this.state.isUpdate ? { color: "lightgrey" } : {}}
          readOnly={this.state.isUpdate}
        />
      </div>
    );
  }
}

// This is the preview component
export const LowerCaseInputPreview = ({ value }) => <div>Url: {value}</div>;
